import React from 'react';
import { TRACKING } from 'common/constants/constants';
import resourceAllocationImage from 'images/resourceAllocationCta.jpg';
import CtaPage from 'components/CtaPage';
import { TEXT_POSITION } from 'components/CtaPage/constants';

const SECTION_TYPES = {
  TIME_SELECTION: 'TEAM_SELECTION',
  ALLOCATION_OVER_TIME: 'ALLOCATION_OVER_TIME',
  ALLOCATION_BY_ISSUE_TYPE: 'ALLOCATION_BY_ISSUE_TYPE',
  ITEMS: 'ITEMS'
};

const TEXTS = {
  [SECTION_TYPES.TIME_SELECTION]:
    'The Resource Allocation dashboard ' +
    'automatically configures your initiatives, projects, and epics to ' +
    'provide high level cost and effort metrics across any time period.',
  [SECTION_TYPES.ALLOCATION_OVER_TIME]:
    'Use the Allocation Over Time view to visualize how your ' +
    "team's effort is distributed across projects per month or week. " +
    'This view helps leaders understand what their teams are ' +
    'prioritizing and project trends.',
  [SECTION_TYPES.ALLOCATION_BY_ISSUE_TYPE]:
    'Full Time Effort Allocation by Issue Type helps engineering ' +
    'leaders visualize the amount of effort being allocated to ' +
    'a specific ticket type across all projects.',
  [SECTION_TYPES.ITEMS]:
    'Dive deeper into each of your initiatives, epics, ' +
    'and projects to gain insights into the % of total work, ' +
    'overall project cots, full time effort, and more.'
};

const ResourceAllocationCta = () => (
  <CtaPage
    textsMap={TEXTS}
    page={TRACKING.PAGES.RESOURCE_ALLOCATION}
    pageTab={TRACKING.PAGE_TABS.RESOURCE_ALLOCATION_CTA}
    buttonLineProps={{
      textWidth: '70%',
      leftText: 'UNLOCK RESOURCE ALLOCATION TO SEE PROJECT COST & EFFORT!',
      buttonText: 'BOOK A DEMO NOW'
    }}
    backgroundImage={resourceAllocationImage}
    sections={[
      {
        sectionType: SECTION_TYPES.TIME_SELECTION,
        buttonPosition: {
          left: '50%',
          top: '4rem'
        },
        coverProps: {
          height: '8rem',
          width: '100%',
          position: { top: 0 }
        },
        textPosition: {
          right: TEXT_POSITION,
          top: '-3rem'
        }
      },
      {
        sectionType: SECTION_TYPES.ALLOCATION_BY_ISSUE_TYPE,
        buttonPosition: {
          left: '43%',
          top: '14rem'
        },
        coverProps: {
          height: '18rem',
          width: '50%',
          position: { top: '8rem' }
        },
        textPosition: {
          left: TEXT_POSITION,
          top: '14rem'
        },
        isTextLeft: true
      },
      {
        sectionType: SECTION_TYPES.ALLOCATION_OVER_TIME,
        buttonPosition: {
          right: '23%',
          top: '12.5rem'
        },
        coverProps: {
          height: '18rem',
          width: '50%',
          position: { right: 0, top: '8rem' }
        },
        textPosition: {
          right: TEXT_POSITION,
          top: '14rem'
        }
      },
      {
        sectionType: SECTION_TYPES.ITEMS,
        buttonPosition: {
          left: '40%',
          bottom: '14.5rem'
        },
        coverProps: {
          height: '22rem',
          width: '100%',
          position: { bottom: 0, top: '26rem' }
        },
        textPosition: {
          right: TEXT_POSITION,
          bottom: '7rem'
        }
      }
    ]}
  />
);

export default ResourceAllocationCta;
